export default function KootstraIcon ({ className, size = 1, viewBox = '0 0 37.472937 22.506816' }: {
  className?: string
  viewBox?: string
  size?: number
}): JSX.Element {
  return (
    <svg
      width={36 * size}
      height={16 * size}
      viewBox={viewBox}
      version='1.1'
      id='svg1'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <defs
        id='defs1'
      />
      <g
        id='layer1'
        transform='translate(-0.00726765,-0.00122813)'
      >
        <g
          id='g1'
          transform='translate(-86.246898,-137.31782)'
        >
          <path
            d='m 110.81015,138.71575 c 0,0 -0.89165,0.92075 -0.79375,1.29646 0.3122,1.21973 0.80697,2.24896 3.18293,6.81831 1.83092,3.5269 2.6379,4.15925 2.6379,4.15925 0,0 0.22754,-0.23019 0.5715,0.39687 0.33867,0.62707 0.28839,0.5715 -0.11113,0.91282 -0.40216,0.3466 -0.74348,0.17462 -0.97102,-0.23019 -0.23018,-0.39158 -0.23018,-0.45508 -0.23018,-0.45508 0,0 0.84666,1.79916 -2.28336,-3.67771 -2.04523,-3.57452 -3.17235,-6.31561 -3.70946,-7.78934 -0.28575,-0.78316 0.61648,-1.43139 0.61648,-1.43139 h 0.0132'
            id='path1'
            fill='currentColor'
            strokeWidth='0.264583'
          />
          <polyline
            points='258.87,316.29 233.95,351.76 235,357.23 260.79,319.08 258.87,316.29 '
            id='polyline1'
            fill='currentColor'
            transform='matrix(0.26458333,0,0,0.26458333,42.156063,58.801)'
          />
          <polyline
            points='212.91,305.3 236.47,350.13 236.64,353.15 236.41,354.02 234.09,354.02 209.47,306.37 212.91,305.3   '
            id='polyline2'
            fill='currentColor'
            transform='matrix(0.26458333,0,0,0.26458333,42.156063,58.801)'
          />
          <polyline
            points='197.17,350.33 230.15,350.33 230.59,352.72 196.96,352.72 197.17,350.03 '
            id='polyline3'
            fill='currentColor'
            stroke='currentColor'
            transform='matrix(0.26458333,0,0,0.26458333,42.156063,58.801)'
          />
          <polyline
            points='214.13,313.98 195.66,348.83 199.53,348.83 215.93,318.88 214.13,314.55 '
            id='polyline4'
            fill='currentColor'
            transform='matrix(0.26458333,0,0,0.26458333,42.156063,58.801)'
          />
          <path
            d='m 96.541166,138.3321 c 0,0 -0.502708,0.0688 -0.629708,0.31221 -0.121708,0.254 -0.177271,0.32279 -0.248708,0.56621 -0.05292,0.17727 -0.187854,0.62706 0.06085,0.81227 0.256646,0.19579 0.187854,0.56621 0.439208,0.44185 0.251354,-0.11906 0.627063,-0.3122 1.068917,-0.37041 0.441854,-0.0714 2.076979,-0.18786 2.447396,-0.18786 0.378359,0 0.566209,0 1.068919,0 0.50006,0 0.87842,0.0582 0.56621,-0.3122 -0.31485,-0.381 -1.320275,-0.635 -1.756838,-0.69586 -0.441854,-0.0556 -3.01625,-0.56621 -3.01625,-0.56621'
            id='path4'
            fill='currentColor'
            strokeWidth='0.264583'
          />
          <path
            d='m 117.04108,151.78087 c 0,0.58473 -0.4736,1.05305 -1.05304,1.05305 -0.58473,0 -1.05569,-0.47096 -1.05569,-1.05305 0,-0.58208 0.47361,-1.05304 1.05569,-1.05304 0.57679,0 1.05304,0.47096 1.05304,1.05304'
            id='path5'
            fill='currentColor'
            strokeWidth='0.264583'
          />
          <path
            d='m 123.13708,152.09308 c 0,3.95817 -3.20675,7.16492 -7.16227,7.16492 -3.95816,0 -7.16491,-3.20675 -7.16491,-7.16492 0,-3.95287 3.20675,-7.16491 7.16491,-7.16491 3.95552,0.003 7.16227,3.21468 7.16227,7.16491 z m -21.96835,-0.17991 c 0,3.96081 -3.204105,7.1702 -7.162272,7.1702 -3.960812,0 -7.164916,-3.20939 -7.164916,-7.1702 0,-3.95817 3.204104,-7.16757 7.164916,-7.16757 3.958167,0.003 7.162272,3.21204 7.162272,7.16757 z'
            id='path6'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.13522'
          />
          <rect
            x='86.254166'
            y='138.36385'
            width='37.472939'
            height='21.002625'
            id='rect6'
            fill='none'
            strokeWidth='0.264583'
          />
          <path
            d='m 95.247354,151.61948 c 0,0.57679 -0.468312,1.05304 -1.053042,1.05304 -0.584729,0 -1.053041,-0.47625 -1.053041,-1.05304 0,-0.58738 0.470958,-1.06363 1.053041,-1.06363 0.587375,0 1.053042,0.47625 1.053042,1.06363'
            id='path7'
            fill='currentColor'
            strokeWidth='0.264583'
          />
          <path
            d='m 105.81217,152.35767 c 0,0.78316 -0.635,1.41552 -1.41552,1.41552 -0.78317,0 -1.41553,-0.635 -1.41553,-1.41552 0,-0.78317 0.635,-1.41553 1.41553,-1.41553 0.78052,-0.003 1.41552,0.63236 1.41552,1.41553 z'
            id='path8'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.817351'
          />
          <line
            x1='94.255165'
            y1='152.33121'
            x2='104.12148'
            y2='153.89754'
            id='line8'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.264583'
          />
          <line
            x1='94.207542'
            y1='151.0956'
            x2='104.39664'
            y2='150.79134'
            id='line9'
            fill='none'
            stroke='currentColor'
            strokeWidth='0.264425'
          />
          <path
            d='M 112.09073,137.45633'
            id='path9'
            fill='none'
            stroke='#000000'
            strokeWidth='1.05833'
            strokeLinecap='round'
          />
          <polyline
            points='260.84,298.51 262.86,298.8 259.28,304.67 253.23,309 250.08,308.8 '
            id='polyline9'
            fill='none'
            stroke='currentColor'
            strokeWidth='3.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            transform='matrix(0.26458333,0,0,0.26458333,42.156063,58.801)'
          />
        </g>
      </g>
    </svg>

  )
}
